import Tree from 'react-ui-tree';

export default class FixedTree extends Tree {
  getDraggingDom = () => null;
  dragStart = () => {};
  drag = () => {};
  dragEnd = () => {};
}
